var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countrys-Map",staticStyle:{"height":"50vh","width":"90vw","margin":"0 auto"}},[_c('div',{attrs:{"id":"container","height":"100%"}})])
}]

export { render, staticRenderFns }